var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { createSubcomponent } from '@workday/canvas-kit-react/common';
import { Card } from '@workday/canvas-kit-react/card';
import { usePopupModel } from './hooks';
export var PopupBody = createSubcomponent('div')({
    displayName: 'Popup.Body',
    modelHook: usePopupModel,
})(function (elemProps) {
    return React.createElement(Card.Body, __assign({ overflowY: "auto", padding: "xxs" }, elemProps));
});
